import { getAccessToken } from "../utils/tokenUtils";
import { logout } from "../utils/loginUtils";

export const serverUrl = process.env.REACT_APP_API_URL;

export const getAuthHeader = () => {
  return {
    headers: {
      Authorization: getAccessToken(),
    },
  };
};

export const downloadLink = (link: string) => {
  fetch(link)
    .then((res: any) => res.blob())
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = link.split("/")[link.split("/").length - 1];
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 1000);
      a.remove();
    })
    .catch((err) => {
      console.error("err", err);
    });
};

export const errorHandler = (error: any) => {
  if (error.response) {
    console.error(error.response.data);
  } else if (error.request) {
    console.error(error.request);
  } else {
    console.error(error.message);
  }

  if (error.response?.status === 401) {
    if (getAccessToken()) {
      alert("로그인이 필요합니다.");
      logout();
    }
  }

  if (error.response?.status === 403) {
    alert("권한이 없습니다.");
  }
};

export const onRetry = (failureCount: number, error: any) => {
  console.log(error);
  return (
    failureCount <= 2 && (error.status === 500 || error.code === "ERR_NETWORK")
  );
};
